/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, { useState } from 'react'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from 'reactstrap'
import './modalStatus.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTimes,
  faCheckCircle,
  faArrowDown,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons'
import ICoin from '../../images/coin.png'
import IToken from '../../images/token.png'
import { NAME_TOKEN } from '../../constants'
import { useModalStatus } from '../../hooks/useModalStatus' 


interface IProps {
  // modalStatus: any
  // summaryCoin?: string
  // summaryToken?: string
  onConfirm: () => void
  // onCloseModal: () => void
  compContent?: any
}

const ModalStatus = (props: IProps) => {
  const {
    // onCloseModal,
    // modalStatus,
    // summaryCoin,
    // summaryToken,
    onConfirm,
    compContent,
  } = props

  const {   setShowModal,  modalStatusState ,setCloseModalStatus } = useModalStatus()
  // const {  isShowModalStatus } = modalStatusState
  // const { title, contentType, isShowModalStatus, icon } = modalStatus
  const { title, contentType, isShowModalStatus, icon } = modalStatusState

  const toggle = () => setCloseModalStatus()

  const onClickButton = () => {
    if (contentType === 'content') {
      onConfirm()
    } else {
     // toggle()
      setCloseModalStatus()
    }
  }

  return (
    <div>
      <Modal
        isOpen={isShowModalStatus}
        toggle={toggle}
        className={'modal-status'}
        centered
        backdrop='static'
      >
        <div className='modal-header'>
          <h5 className='modal-title'>{title}</h5>
          <button
            type='button'
            onClick={toggle}
            className='btn close'
            aria-label='Close'
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <ModalBody>
          <div className=' modal-status-content '>
            {contentType === 'success' ? (
              <FontAwesomeIcon icon={faCheckCircle} />
            ) : contentType === 'loading' ? (
              <div className='d-flex justify-content-center align-item-center'>
                <Spinner className='loading-spinner' children='' />
              </div>
            ) : contentType === 'fail' ? (
              <FontAwesomeIcon icon={faTimesCircle} />
            ) : contentType === 'content' ? (
              compContent
            ) : null}
          </div>
        </ModalBody>
        <ModalFooter>
          {contentType === 'loading' ? null : (
            <div className='modal-status-footer'>
              <button onClick={onClickButton} className='btn close-btn'>
                {contentType === 'content' ? 'Confirm' : 'Close'}
              </button>
            </div>
          )}
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default ModalStatus
